import React from "react";

import { CustomButton, CustomDialog, FeaturedIcon } from "../../../components";

import css from "./modal-account.module.css";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";
import { useNavigate } from "react-router-dom";

const ModalAccountRemove = ({
  open,
  onClose,
  account
}) => {
const navigate = useNavigate();
    const { mutateAsync: submitRequest, isLoading, } = useMutation({
      mutationKey: "removeStratAccount",
      networkMode: "always",
      mutationFn: async () =>  await RebatesClient.deleteAccount(account.id),
      onError: (err)=> {console.log(err)},
      onSuccess: (resp) => {
        console.log(resp)
        if(resp.response.status == 200){
          navigate('/accounts', {replace:true})
        }
        else {
          alert(`Error removing account, ${resp.body.status}`)
        }
  
      }
    });
    


	const title = (
		<div className={css.modalTitle}>
			<FeaturedIcon icon="Trash" />
      Remove Account
		</div>
	);

  return (
      <CustomDialog open={open} onClose={onClose} width={640} title={title}>
        {/* <FormikProvider value={formik}> */}
          <div className={css.modalForm}>
            <div className={css.formContent}>
              <div className={css.formGroup}>
                <p>Are you sure you want to remove <strong>{account.name}</strong></p>
              </div>
            </div>

            <div className={css.actions}>
              <CustomButton
                label="Remove"
                type="submit"
                color="danger"
                disabled={isLoading}
                onClick={()=>submitRequest()}
              />
            </div>
          </div>
        {/* </FormikProvider> */}
      </CustomDialog>
  );
}

export default ModalAccountRemove;
